<template>
	<modal-box @close="close" :header="$t(`buttons.actions.${params.action}_disease`)"  :subHeader="$t('headers.general.disease')" class="watch-profile-disease-form">
		<spinner v-if="model.loading"/>
		<error-box v-else-if="model.error" :error="model.error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-select v-model="model.data.name_id" :options="options" name="disease_name_id" :placeholder="$t('labels.general.disease')" rules="required"/>
			<input-textarea v-model="model.data.comments" name="disease_comments" :placeholder="$t('labels.general.comments')"/>
			<error-box v-if="form.error" :error="form.error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
export default {
	props: [
		'user_uid',
		'watch_id',
		'params'
	],
	data () {
		return {
			model: new ApiObject(),
			form: {
				loading: false,
				error: ''
			},
			options: []
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			switch (this.params.action) {
				case 'add':
					this.addDisease()
					break
				case 'edit':
					this.editDisease()
					break
				default:
					this.$log.warn('watch profile disease form', 'action not set')()
			}
		},
		close (reload = false) {
			this.$emit('close', { reload })
		},
		getDiseaseNames () {
			this.$api.profile.diseases.getNames(this)
				.then(response => {
					this.$log.info('watch profile disease form', 'profile.diseases.getNames OK', response)()
					this.options = []
					response.body.forEach(element => {
						this.options.push({ value: element.id, text: this.$t('categories.diseases.'+element.name.replace(/ /g, '_').replace(/'/g, '´').toLowerCase()) })
					})
				}).catch(error => {
					this.$log.error('watch profile disease form', 'profile.diseases.getNames ERROR', error)()
					this.form.error = error
				})
		},
		getDisease () {
			this.model.loading = true
			this.$api.profile.diseases.get(this, this.user_uid, this.watch_id, this.params.id)
				.then(response => {
					this.$log.info('watch profile disease form', 'profile.diseases.get OK', response)()
					this.model.data = response.body
				}).catch(error => {
					this.$log.error('watch profile disease form', 'profile.diseases.get ERROR', error)()
					this.model.error = error
				}).finally(() => {
					this.model.loading = false
				})
		},
		addDisease () {
			this.form.loading = true
			this.$api.profile.diseases.add(this, this.user_uid, this.watch_id, this.model.data)
				.then(response => {
					this.$log.info('watch profile disease form', 'profile.diseases.add OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch profile disease form', 'profile.diseases.add ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		editDisease () {
			this.form.loading = true
			this.$api.profile.diseases.edit(this, this.user_uid, this.watch_id, this.model.data)
				.then(response => {
					this.$log.info('watch profile disease form', 'profile.diseases.edit OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch profile disease form', 'profile.diseases.edit ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		}
	},
	created () {
		this.getDiseaseNames()
		switch (this.params.action) {
			case 'add':
				this.model.data = {
					name_id: '',
					comments: ''
				}
				break
			case 'edit':
				this.getDisease()
				break
			default:
				this.$log.warn('watch profile disease form', 'action not set')()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/profile/DiseaseForm.vue